export const API_BASE_URL = "https://api.infiniese.com/portfolio-api";

export const API_BASE_URL_LOCAL = "http://localhost:8000/portfolio-api";

export const COMPANY_NAME = "Infiniese";